import Log from '@/models/utils/log';
import AttributeAbstract from '@/models/attribute/abstract';

const namespace = 'models.attribute.settings';

export default class AttributeSettings extends AttributeAbstract {

}
